// removed by extract-text-webpack-plugin
module.exports = {"list-highlight-need-offer":"list-highlight-need-offer","highlight-need-offer-item":"highlight-need-offer-item","item-description":"item-description","item-link":"item-link","company-content":"company-content","item-wrap-image":"item-wrap-image","item-image":"item-image","item-left-content":"item-left-content","item-user-name":"item-user-name","item-right-content":"item-right-content"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/HighlightNeedOffer/style.scss
// module id = ./components/home/sub-view/HighlightNeedOffer/style.scss
// module chunks = 0